import { uid } from "./domain";
export function seed() {
  const categories = [
    ["Mujeres", "✦"],
    ["Hombres", "↗"],
    ["Bebés & niños", "☀"],
    ["Hogar", "⌂"],
  ].map(([name, icon], i) => ({
    id: uid(),
    name,
    icon,
    parent_id: null,
    active: true,
    featured: true,
    sort_order: i,
  }));
  const input = [
    ["Porta laptop antirrobo", "LAPT", 25, 30, 1, ["Gris", "Negro"]],
    ["Mochila antirrobo", "MOI", 30, 35, 0, ["Rojo", "Negro"]],
    ["Mochila Oxford", "MOX", 18, 20, 0, ["Negro", "Beige"]],
    [
      "Bolso 3 en 1",
      "BEX",
      45,
      65,
      0,
      ["Lila", "Negro", "Plomo", "Rosa", "Azul"],
    ],
    ["Joyero viajero", "JOY", 25, 27, 0, ["Turquesa", "Rosa", "Blanco"]],
    ["Mochila Love", "MOLO", 25, 28, 0, ["Negro", "Rosa"]],
    ["Rodilleras para bebé", "ROB", 8, 10, 2, ["Rosa", "Azul"]],
    ["Abridor magnético", "ABR", 13, 15, 3, ["Verde", "Negro"]],
  ];
  const colors = {
    Gris: "#777b85",
    Negro: "#28272c",
    Rojo: "#b93244",
    Beige: "#d6c7b0",
    Lila: "#b598d5",
    Plomo: "#8c8d91",
    Rosa: "#e5adb9",
    Azul: "#608cba",
    Turquesa: "#37b9aa",
    Blanco: "#efefef",
    Verde: "#158c78",
  };
  const products = input.map(([name, sku, price, compare_price, cat], i) => ({
    id: uid(),
    name,
    sku,
    price,
    compare_price,
    category_id: categories[cat].id,
    description: `${name}: un detalle práctico para acompañarte todos los días. Elige tu color favorito y consulta la disponibilidad.`,
    images: [],
    demo_image: i,
    video_url: "",
    active: true,
    featured: [0, 1, 3, 4].includes(i),
    sort_order: i,
    wholesale_price: 0,
    wholesale_min: 6,
  }));
  const variants = products.flatMap((p, i) =>
    input[i][5].map((color, j) => ({
      id: uid(),
      product_id: p.id,
      color,
      hex: colors[color],
      sku: `${p.sku}-${color.substring(0, 3).toUpperCase()}`,
      stock: i === 2 ? 0 : (j + 1) * 4,
      low_stock: 3,
      active: true,
      image: "",
    })),
  );
  return {
    store: {
      id: uid(),
      name: "Dilo Shop",
      slug: "dilo-shop",
      logo: "/assets/logo.png",
      banner: "",
      headline: "Dilo con tu estilo.",
      tagline: "Pequeños detalles. Grandes favoritos.",
      announcement: "Encuentra ese algo que va contigo ✦",
      whatsapp: "",
      email: "",
      address: "",
      shipping_fee: 10,
      free_shipping: 150,
      yape: "",
      plin: "",
      bank: "",
      payment_instructions:
        "Después de realizar tu pedido, coordina el pago con la tienda.",
      instagram: "",
      facebook: "",
      tiktok: "",
      published: true,
      pages: [],
      blog: [],
    },
    categories,
    products,
    variants,
    orders: [],
    movements: [],
    events: [],
    members: [
      {
        user_id: "demo-owner",
        name: "Mi tienda",
        email: "demo@dilo.local",
        role: "owner",
      },
    ],
    visits: 0,
  };
}
